"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _ = require("../../");

var _index = require("../../helpers/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CompanyLookup = function CompanyLookup(_ref) {
  var _extraValues$region, _extraValues$register2;

  var id = _ref.id,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      extraValues = _ref.extraValues,
      errorCb = _ref.errorCb,
      t = _ref.t,
      cleanValues = _ref.cleanValues,
      _ref$companyLookUpIns = _ref.companyLookUpInstructions,
      setStructureData = _ref$companyLookUpIns.setStructureData,
      _ref$companyLookUpIns2 = _ref$companyLookUpIns.collectStructure,
      collectStructure = _ref$companyLookUpIns2 === void 0 ? true : _ref$companyLookUpIns2,
      customFieldsArray = _ref$companyLookUpIns.customFieldsArray,
      supportedCountries = _ref$companyLookUpIns.supportedCountries,
      sendNotification = _ref$companyLookUpIns.sendNotification,
      url = _ref$companyLookUpIns.url,
      db = _ref$companyLookUpIns.db;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)({
    text: 'button.companyFilled',
    type: 'successAqua',
    icon: _.CheckMark
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      buttonConfig = _useState4[0],
      setButtonConfig = _useState4[1];

  var countryToCheck = extraValues.registeredAddressCountry && (extraValues.registeredAddressCountry.value || extraValues.registeredAddressCountry);
  var region = (_extraValues$region = extraValues.region) === null || _extraValues$region === void 0 ? void 0 : _extraValues$region.value;
  var countryIsNotSupported = countryToCheck && supportedCountries && !supportedCountries.includes(countryToCheck);

  _react.default.useEffect(function () {
    var _extraValues$register;

    if (extraValues !== null && extraValues !== void 0 && extraValues.name && extraValues !== null && extraValues !== void 0 && (_extraValues$register = extraValues.registeredAddressCountry) !== null && _extraValues$register !== void 0 && _extraValues$register.value && extraValues !== null && extraValues !== void 0 && extraValues.registrationNumber) {
      (url === null || url === void 0 ? void 0 : url.checkCompanyExists) && db('get', url.checkCompanyExists({
        companyRegistrationNumber: extraValues.registrationNumber,
        companyCountry: extraValues.registeredAddressCountry.value
      }));
    }
  }, [extraValues === null || extraValues === void 0 ? void 0 : extraValues.name, extraValues === null || extraValues === void 0 ? void 0 : (_extraValues$register2 = extraValues.registeredAddressCountry) === null || _extraValues$register2 === void 0 ? void 0 : _extraValues$register2.value, extraValues === null || extraValues === void 0 ? void 0 : extraValues.registrationNumber]);

  var searchAndSetDataFromCompany = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var companyDetails, company, structure, filteredCompany, keys, values;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return (0, _.checkCompanyHouseFn)({
                values: _objectSpread(_objectSpread({}, extraValues), {}, {
                  registeredAddressCountry: countryToCheck
                }),
                sendNotification: sendNotification,
                url: url.checkCompanyHouse(_objectSpread(_objectSpread({}, extraValues), {}, {
                  registeredAddressCountry: countryToCheck,
                  region: region
                })),
                db: db
              });

            case 3:
              companyDetails = _context.sent;
              company = companyDetails.company || {};

              if (collectStructure && company.structure) {
                structure = (0, _cloneDeep.default)(company.structure);
                setStructureData(structure);
                delete company.structure;
              }

              filteredCompany = Object.entries(company).reduce(function (acc, _ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    key = _ref4[0],
                    val = _ref4[1];

                if (customFieldsArray.includes(key) || key === 'externalIdentifier') {
                  acc[key] = val;
                }

                return acc;
              }, {});
              keys = Object.keys(filteredCompany);
              values = Object.values(filteredCompany);
              keys.map(function (key, i) {
                return onChange(key, key === 'registrationDate' ? (0, _index.convertToLocaleDateYYYYMMDD)(values[i]) : values[i]);
              });
              !(0, _isEmpty.default)(company) && onChange(id, _objectSpread(_objectSpread({}, extraValues), {}, {
                country: countryToCheck,
                name: company.name
              }));
              setButtonConfig({
                text: 'button.companyFilled',
                type: 'successAqua',
                icon: _.CheckMark
              });
              setLoading(false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function searchAndSetDataFromCompany() {
      return _ref2.apply(this, arguments);
    };
  }();

  var cleanUpFields = function cleanUpFields() {
    cleanValues();
    collectStructure && onChange('sameAddress', false);
  };

  var onMouseout = function onMouseout() {
    return setButtonConfig({
      text: 'button.companyFilled',
      type: 'successAqua',
      icon: _.CheckMark
    });
  };

  var onMouseover = function onMouseover() {
    return setButtonConfig({
      text: 'button.resetSearch',
      type: 'warning',
      icon: _.XMark
    });
  };

  return _react.default.createElement(_.FlexContainer, {
    column: true,
    margin: "1rem 0",
    justifyContent: "space-between"
  }, _react.default.createElement(_.Button, {
    t: t,
    disabled: disabled || countryIsNotSupported,
    isLoading: loading,
    onMouseLeave: onMouseout,
    onMouseEnter: onMouseover,
    padding: ".5rem",
    type: value && buttonConfig.type,
    value: value ? _react.default.createElement(_.FlexContainer, {
      alignItems: "center",
      justifyContent: "space-between"
    }, _react.default.createElement("div", null), typeof t === 'function' && t(buttonConfig.text), _react.default.createElement(buttonConfig.icon, {
      size: '12',
      fill: 'white'
    })) : countryIsNotSupported ? t('countryNotSupported') : t("companyLookup"),
    onClick: function onClick() {
      return value ? cleanUpFields() : searchAndSetDataFromCompany();
    },
    fixDimension: {
      width: '100%'
    }
  }));
};

var _default = CompanyLookup;
exports.default = _default;